import { EnumDialogName } from '@calm/evexia-analytics';
import { AudioPlayerDialog } from '@rhg/components/media/audio-player-dialog';
import { AudioPlayerDrawer } from '@rhg/components/media/audio-player-drawer';
import { useCallback } from 'react';
import { AudioPlayerControls } from '../audio-player/types';
import { AudioPlayerCombinedProps } from './types';

export function AudioPlayerCombined({
    openState = false,
    title,
    subtitle,
    description,
    imageSrc,
    autoplay,
    drawerAction,
    dialogAction,
    dialogBottomAction,
    dialogBottomActionHeight,
    dialogSupportsAddToPlaylist,
    dialogOnAddToPlaylist,
    dialogAreControlsPinned,
    drawerTitleIcon,
    narrator,
    author,
    playerAudio,
    previousProgress,
    controls = AudioPlayerControls.Regular,
    supportsPlaybackSpeed,
    centerAction,
    setOpenState,
    onProgress,
    onClose,
    onEnd,
    onNextTrack,
    onPreviousTrack,
    trackDialog = EnumDialogName.AudioPlayer,
    trackProps,
    onControlClick,
}: AudioPlayerCombinedProps) {
    const onMaximize = useCallback(() => {
        setOpenState('dialog');
    }, [setOpenState]);

    const onMinimize = useCallback(() => {
        setOpenState('drawer');
    }, [setOpenState]);

    const onEndCallback = useCallback(() => {
        onEnd?.();
    }, [onEnd]);

    if (!playerAudio) {
        return null;
    }
    switch (openState) {
        case 'drawer':
            return (
                <AudioPlayerDrawer
                    audio={playerAudio}
                    isOpen
                    title={title}
                    drawerTitleIcon={drawerTitleIcon}
                    subtitle={subtitle}
                    imageSrc={imageSrc}
                    controls={controls}
                    supportsPlaybackSpeed={supportsPlaybackSpeed}
                    autoplay={autoplay}
                    previousProgress={previousProgress}
                    customAction={drawerAction}
                    onMaximize={onMaximize}
                    onProgress={onProgress}
                    onEnd={onEndCallback}
                    onClose={() => onClose?.()}
                    onNextTrack={onNextTrack}
                    onPreviousTrack={onPreviousTrack}
                    onControlClick={onControlClick}
                />
            );

        case 'dialog':
            return (
                <AudioPlayerDialog
                    audio={playerAudio}
                    isOpen
                    title={title}
                    description={description}
                    narrator={narrator}
                    author={author}
                    imageSrc={imageSrc}
                    isCloseButtonDisplayed={true}
                    controls={controls}
                    supportsPlaybackSpeed={supportsPlaybackSpeed}
                    autoplay={autoplay}
                    trackDialog={trackDialog}
                    trackProps={trackProps}
                    previousProgress={previousProgress}
                    onMinimize={onMinimize}
                    upperActionButton={dialogAction}
                    supportsAddToPlaylist={dialogSupportsAddToPlaylist}
                    onAddToPlaylist={dialogOnAddToPlaylist}
                    areControlsPinned={dialogAreControlsPinned}
                    centerAction={centerAction}
                    dialogBottomAction={dialogBottomAction}
                    dialogBottomActionHeight={dialogBottomActionHeight}
                    onProgress={onProgress}
                    onEnd={onEndCallback}
                    onClose={() => onClose?.()}
                    onNextTrack={onNextTrack}
                    onPreviousTrack={onPreviousTrack}
                    onControlClick={onControlClick}
                />
            );

        default:
            return null;
    }
}
